<template lang="html">
    <div style="height:100%;">
        <div class="handleBox flex flex-jc-sb flex-ai-c">
            <p class="title">赠送规则 ></p>
            <div></div>
        </div>
		
        <div class="zsBox">
            <div class="flex zsList">
                <div class="flex flex-ai-fs" style="height:auto;width:90%">
                    <label>赠送规则：</label>
					<editorBar :editorMain="content" @change="editorChange" :mayEdit="show"></editorBar>
                </div>
            </div>
            <el-button type="primary" size="small" style="margin:50px auto 0;display: block;width:250px" @click="submit">确定</el-button>
        </div>
    </div>
</template>

<script>
import editorBar from '@/components/editorBar';
export default {
    data() {
        return {
            content:'',
			show:false
        }
    },
	components: {
		editorBar, //富文本编辑器
	},
    mounted() {
        this.getData();
    },
    methods: {
		/**
		* 接收富文本子组件输入值
		*/
		editorChange: function(value) {
			this.content = value;
		},
		
        getData() {
            this.http.post('/admin/service/read').then(re => {
                this.content = re.content?re.content:'';
            })
        },

        submit() {
            if (!this.content) {
                this.$message.error('不得为空！')
            } else {
                this.http.post('/admin/service/edit', {content:this.content}).then(() => {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                })
            }
        }
    }
}
</script>
